// Protected route component

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/sdk/auth/hooks';
import { LoadingSpinner } from '@/design-system/components/LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireOrg?: boolean;
}

/**
 * Component to protect routes that require authentication
 */
export function ProtectedRoute({ children, requireOrg = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, currentOrg } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner message="Loading..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/client/login" state={{ from: location }} replace />;
  }

  if (requireOrg && !currentOrg) {
    return <Navigate to="/client/orgs" replace />;
  }

  return <>{children}</>;
}
